export default __webpack_public_path__ + "static/Kira Kutcher - Age 4-05f67570e28c150cda97b51833db9bcc.png";